import { fetch } from "~/utils/helper";
import { LANGUAGES, tagOfCode } from "~/utils/locale";

// The dashboard's language: the five of the Studio, chosen in the account menu or on the screens before it. A choice
// applies at once, stays in this browser (the i18n cookie) and, for a signed-in person, follows them to their other
// devices (`users.locale`, PATCH /users/@me, read back at sign-in by middleware/auth.global.js).
export const useLanguage = () => {
  const nuxtApp = useNuxtApp();
  const { locale, setLocale } = useI18n();

  const setLanguage = async (code) => {
    if (!LANGUAGES.some((language) => language.code === code) || code === locale.value) return;
    await setLocale(code);
    const user = nuxtApp.$user;
    if (!user?.id) return;
    try {
      await fetch("/users/@me", { method: "PATCH", body: { language: tagOfCode(code) } });
      user.language = tagOfCode(code);
    } catch { /* the choice still holds in this browser */ }
  };

  return { languages: LANGUAGES, locale, setLanguage };
};
